<template>
  <div>
    <h4>{{ (requiredData||{}).casePartyName }}</h4>

    <div v-if="!showSelectedPartyToRepresent">
      <naj-box :title="local.caseRelatedRequest.relatedPartyInfo">
        <div class="pa-3 content-wrapper">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.applicantCasePartyId"
            :label="local.caseRelatedRequest.relatedPartyInfo"
            :items="caseParties"
            item-value="casePartyId"
            item-text="name"
            validates="required"
            :disabled="casePartiesSelectboxDisabled"
            @change="selectedCasePartySocialIdChanged"
          ></naj-input>
        </div>
      </naj-box>

      <naj-box
        v-if="formModel.applicantCasePartyId"
        :title="local.caseRelatedRequest.applicantCaseParty"
      >
        <naj-data-table
          no-header
          disable-items-per-page
          :headers="tableHeader"
          :loading="loading"
          :items="formModel ? [...formModel] : []"
          :no-margin-bottom="false"
        >
        </naj-data-table>
      </naj-box>
    </div>

    <naj-box
      v-if="isRepresentativeCurrentUser"
      :title="local.caseRelatedRequest.representativeCaseParty"
    >
      <v-row v-if="isNewMode">
        <v-col cols="4">
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.caseRelatedRequest.representativeType"
            :value.sync="formModel.representationInfoDetails.casePartyRole"
            :items="representativesList"
            :disabled="isViewMode"
            item-value="id"
            item-text="title"
            validates="required"
          ></naj-input>
        </v-col>
        <v-col
          v-if="showAddCurrentUserCheckbox"
          cols="4"
        >
          <naj-input
            :type-id="formFieldType.checkbox"
            :label="local.caseRelatedRequest.addMyInfoRepresentative"
            :value.sync="isRepresentativeCurrentUser"
            :disabled="isViewMode"
            @change="isRepresentativeCurrentUserChanged"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <naj-input
            v-mask="'05########'"
            :type-id="formFieldType.text"
            :label="local.contact.mobile"
            :value.sync="formModel.representative.mobile"
            :validates="`required|digits:10`"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <personal-form
      v-else
      :title="local.caseRelatedRequest.representativeCaseParty"
      :form-model="formModel.representative"
      :show-prisoner-form="false"
      :show-needs-translator-form="false"
      :filter-national-regular-residency-social-id="true"
      :required="true"
      :view-mode="isViewMode"
    >
      <v-row v-if="isNewMode">
        <v-col cols="4">
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.caseRelatedRequest.representativeType"
            :value.sync="formModel.representationInfoDetails.casePartyRole"
            :items="representativesList"
            :disabled="isViewMode"
            item-value="id"
            item-text="title"
            validates="required"
            @change="representationInfoDetailsChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="showAddCurrentUserCheckbox"
          cols="4"
        >
          <naj-input
            :type-id="formFieldType.checkbox"
            :label="local.caseRelatedRequest.addMyInfoRepresentative"
            :value.sync="isRepresentativeCurrentUser"
            :disabled="isViewMode"
            @change="isRepresentativeCurrentUserChanged"
          ></naj-input>
        </v-col>
      </v-row>

      <template v-slot:mobile>
        <v-col cols="4">
          <naj-input
            v-mask="'05########'"
            :type-id="formFieldType.text"
            :label="local.contact.mobile"
            :value.sync="formModel.representative.mobile"
            :validates="`required|digits:10`"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </template>
    </personal-form>

    <representative-form
      :form-model="formModel.representative"
      :party-info="formModel.representationInfoDetails"
      required
      :view-mode="isViewMode"
    ></representative-form>
  </div>
</template>

<script>
import PersonalForm from '@/modules/lawsuit/components/step1/party-types/forms/personal-form';
import RepresentativeForm from '@/modules/lawsuit/components/step1/party-types/forms/representative-form';
import { mode, casePartyRoleByIdEnum, partyTypeEnum, socialIdentityTypeEnum, countriesEnum, userType } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'CasePartyRepresentative',
  inject: ['$validator'],
  components: {
    PersonalForm,
    RepresentativeForm,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // representitaveData: {},
      loading: false,
      casePartyRoleByIdEnum,
      isRepresentativeCurrentUser: false,
      representativeRole: null,
      caseParties: [],
      isLoggedInUserExistsAsCaseParty: false,
      userCasePartyRoleInCase: {},
      representativeConfig: {
        2: {
          order: 11,
          1: {
            1: true,
            3: true,
          },
          3: {
            1: true,
            3: true,
          },
          2: { 10: true },
          4: { 10: true },
        },
        5: {
          order: 12,
          1: {
            1: true,
            3: true,
          },
          3: {
            1: true,
            3: true,
          },
          2: { 10: true },
          4: { 10: true },
        },
        10: {
          order: 10,
          1: {
            1: true,
            3: true,
          },
          2: {
            1: true,
            3: true,
          },
          3: {
            1: true,
            3: true,
          },
          4: {
            1: true,
            3: true,
          },
          5: {
            1: true,
            3: true,
          },
          6: {
            1: true,
            3: true,
          },
          15: {
            1: true,
            3: true,
          },
          7: {
            1: true,
            3: true,
          },
          8: {
            1: true,
            3: true,
          },
          9: {
            1: true,
            3: true,
          },
        },
        11: {
          order: 13,
          1: {
            1: true,
            3: true,
          },
        },
      },
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    showAddCurrentUserCheckbox() {
      return +this.requiredData.socialId !== +this.userInfo.socialId && this.userInfo.userType != userType.najizOrganization;
    },
    relatedCasePartyRole() {
      return this.requiredData.casePartyRole;
    },
    relatedPartyType() {
      return this.formModel.partyType;
    },
    representativesList() {
      return Object.keys(this.representativeConfig)
        .filter((key) => {
          const ct = this.representativeConfig[key];
          return (
            ct[this.relatedPartyType] &&
            ct[this.relatedPartyType][this.relatedCasePartyRole]
          );
        })
        .map(key => ({
          id: key,
          title: this.local.common.casePartyRoles[casePartyRoleByIdEnum[key]],
          order: this.representativeConfig[key].order,
        }))
        .sort((a, b) => a.order - b.order);
    },
    tableHeader() {
      const headers = {
        originalFirmParty: [
          {
            value: 'partyTypeName',
            text: this.local.caseRelatedRequest.partyTypeName,
          },
          {
            value: 'firmName',
            text: this.local.caseRelatedRequest.firmName,
          },
          {
            value: 'commercialRegisterationNumber',
            text: this.local.caseRelatedRequest.commercialRegisterationNumber,
          },
          {
            value: 'casePartyRoleName',
            text: this.local.caseRelatedRequest.casePartyRoleName,
          },
        ],
        originalPersonParty: [
          {
            value: 'partyTypeName',
            text: this.local.caseRelatedRequest.partyTypeName,
          },
          {
            value: 'fullName',
            text: this.local.caseRelatedRequest.fullName,
          },
          {
            value: 'socialId',
            text: this.local.caseRelatedRequest.socialId,
          },
          {
            value: 'casePartyRoleName',
            text: this.local.caseRelatedRequest.casePartyRoleName,
          },
        ],
      };

      return headers[this.getPartyKey()];
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.applicantCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
    routeCaseObjectKey() {
      return this.$route.params.caseObjectKey;
    },
    isOrganizationUser() {
      return this.userInfo && this.userInfo.isOrganizationUser;
    },
    showSelectedPartyToRepresent() {
      return !this.routeCaseObjectKey && !this.isOrganizationUser && this.isNewMode;
    },
  },
  watch: {
    relatedPartyType() {
      this.$set(this.formModel.representationInfoDetails, 'relatedPartyType', this.requiredData.partyType || this.formModel.representationInfoDetails.partyType);
    },
    formModel(value) {
      if (value) {
        // this.representitaveData = value.representative;
        var partyType = this.formModel.partyType || this.requiredData.partyType;
        this.$set(this.formModel, 'representationInfoDetails', (this.formModel.representationInfoDetails || {}));
        this.$set(this.formModel, 'representative', (this.formModel.representative || {}));
        if (partyType == partyTypeEnum.person)
          this.$set(this.formModel, 'originalPersonParty', (this.formModel.originalPersonParty || {}));
        else
          this.$set(this.formModel, 'originalFirmParty', (this.formModel.originalFirmParty || {}));
      }
    },
    'formModel.partyType'() {
      this.$set((this.formModel || {}).representationInfoDetails, 'casePartyRole', null);
    },
  },
  mounted() {
    if (this.formModel) {
      if (this.isViewMode || this.isEditMode) {
        this.requiredData = {
          ...(this.formModel.originalPersonParty || this.formModel.originalFirmParty),
          ...this.formModel.representationInfoDetails,
          partyType: this.formModel.partyType,
          mode: this.formModel.mode,
          casePartyRole: this.formModel.representative.casePartyRole || (this.formModel.representationInfoDetails || {}).casePartyRole,
        };
      }
      if (this.formModel.applicantCasePartyId) {
        this.isLoggedInUserExistsAsCaseParty = true;
      }
    }
  },
  created() {
    this.$set(this.formModel, 'representationInfoDetails', (this.formModel.representationInfoDetails || {}));
    this.$set(this.formModel, 'representative', (this.formModel.representative || {}));
    this.$set(this.formModel, 'originalPersonParty', (this.formModel.originalPersonParty || {}));
    this.$set(this.formModel, 'originalFirmParty', (this.formModel.originalFirmParty || {}));

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    const promises = [this.getAddRepresentativeApplicants(params)];
    if (!this.formModel.applicantCasePartyId) {
      promises.push(this.getUserCasePartyRoleInCase(params));
    }
    Promise.all(promises)
      .then((res) => {
        this.caseParties = (!this.isViewMode && !this.showSelectedPartyToRepresent) ? res[0].data.requestApplicants : [...res[0].data.prosecutors, ...res[0].data.defendants];
        this.userCasePartyRoleInCase = this.formModel.applicantCasePartyId ? {} : res[1].data;
        if (!this.formModel.applicantCasePartyId) {
          this.setRelatedPartyAsRequestApplicant();
        }
        this.setFormModelByApplicantCaseParty();
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    ...mapActions([
      'getAddRepresentativeApplicants',
      'getUserCasePartyRoleInCase',
    ]),
    getPartyKey() {
      if (this.formModel && this.formModel.partyType === partyTypeEnum.person) {
        return 'originalPersonParty';
      }
      return 'originalFirmParty';
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.caseParties.find(cp => cp.partyId == this.formModel.applicantCasePartyId || this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
      }
    },
    selectedCasePartySocialIdChanged() {
      this.setFormModelByApplicantCaseParty();
    },
    setFormModelByApplicantCaseParty() {
      const applicantCaseParty = this.caseParties.find(a => a.casePartyId == this.formModel.applicantCasePartyId);
      if (applicantCaseParty) {
        const commonProps = {
          ...applicantCaseParty,
          socialTypeId: applicantCaseParty.socialIDType,
          grandFatherName: applicantCaseParty.gfName,
          commercialRegisterationNumber: applicantCaseParty.commercialRegisterNo,
          unifiedNumber: applicantCaseParty.unifiedNumber,
          firmName: applicantCaseParty.name,
          fullName: applicantCaseParty.name,
        };

        Object.keys(commonProps)
          .map((key) => {
            this.$set(this.formModel, key, commonProps[key]);
            return key;
          });

        Object.keys(commonProps)
          .map((key) => {
            this.$set(this.requiredData, key, commonProps[key]);
            return key;
          });
        this.setRepresentativeRelatedData();
      }
    },
    setRepresentativeRelatedData() {
      var partyType = this.formModel.partyType || this.requiredData.partyType;
      if (partyType == partyTypeEnum.person) {
        if (!this.formModel.originalPersonParty)
          this.$set(this.formModel, 'originalPersonParty', {});
        this.$set(this.formModel.originalPersonParty, 'casePartyObjectKey', this.requiredData.casePartyObjectKey);
        this.$set(this.formModel, 'originalFirmParty', null);
      }
      else {
        if (!this.formModel.originalFirmParty)
          this.$set(this.formModel, 'originalFirmParty', {});
        this.$set(this.formModel.originalFirmParty, 'casePartyObjectKey', this.requiredData.casePartyObjectKey);
        this.$set(this.formModel, 'originalPersonParty', null);
      }

      this.$set(this.formModel.representationInfoDetails, 'socialId', this.formModel.socialId);
      this.$set(this.formModel.representationInfoDetails, 'commercialRegistrationNumber', this.formModel.commercialRegisterNo);
      this.$set(this.formModel.representationInfoDetails, 'unifiedNumber', this.formModel.unifiedNumber);
      this.$set(this.formModel.representationInfoDetails, 'managerSocialId', this.formModel.managerSocialId);
      this.$set(this.formModel.representationInfoDetails, 'relatedPartyType', this.requiredData.partyType || this.formModel.representationInfoDetails.partyType);
      this.$set(this.formModel.representationInfoDetails, 'dateOfBirth', this.formModel.dateOfBirth);

      this.$set(this.formModel, [this.getPartyKey()], {
        socialId: this.formModel.socialId,
        socialIdType: this.formModel.socialTypeId,
        firstName: this.requiredData.firstName,
        fatherName: this.requiredData.fatherName,
        grandFatherName: this.requiredData.grandFatherName,
        familyName: this.requiredData.familyName,
        casePartyObjectKey: this.requiredData.casePartyObjectKey,
        casePartyRole: this.requiredData.casePartyRole,
        casePartyType: this.requiredData.casePartyType,
        commercialRegisterationNumber: this.requiredData.commercialRegisterNo,
        unifiedNumber: this.requiredData.unifiedNumber,
        firmName: this.requiredData.firmName,
        casePartyRoleName: this.requiredData.casePartyRoleName,
        partyTypeName: this.formModel.partyTypeName,
      });
    },
    isRepresentativeCurrentUserChanged(value) {
      if (value) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel.representative, 'socialIdType', socialTypeId);
        this.$set(this.formModel.representative, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel.representative, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel.representative, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel.representative, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel.representative, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel.representative, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel.representative, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel.representative, 'sex', this.userInfo.gender);
        this.$set(this.formModel.representative, 'isRetrievedFromMoi', true);
      } else {
        this.$set(this.formModel.representative, 'socialIdType', null);
        this.$set(this.formModel.representative, 'socialId', null);
        this.$set(this.formModel.representative, 'firstName', null);
        this.$set(this.formModel.representative, 'fatherName', null);
        this.$set(this.formModel.representative, 'grandFatherName', null);
        this.$set(this.formModel.representative, 'familyName', null);
        this.$set(this.formModel.representative, 'dateOfBirth', null);
        this.$set(this.formModel.representative, 'nationalityCountryId', null);
        this.$set(this.formModel.representative, 'sex', null);
        this.$set(this.formModel.representative, 'isRetrievedFromMoi', false);
      }
    },
    representationInfoDetailsChanged() {
      this.$set(this.formModel.representationInfoDetails, 'representationInfoDetailsChanged', true);
    },
  },
};
</script>
